import { Component, OnInit, output, OnDestroy, inject } from '@angular/core';

import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { Fields, Options } from 'src/app/shared/models/candidateprofile-genmodel';
import { GenModelService } from 'src/app/core/services/gen-model.service';
import { debounce } from 'rxjs/operators';
import { interval } from 'rxjs';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';

@Component({
  selector: 'app-autocomplete',
  standalone: true,
  templateUrl: './autocomplete.component.html',
  styleUrls: [],
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatOption,
    MatError,
  ],
})
export class AutocompleteComponent implements OnInit, OnDestroy {
  private http = inject(HttpClient);
  private apiData = inject(GenModelService);

  field: Fields;
  group: UntypedFormGroup;
  filteredOptions: Options[] = [];
  digitalTags: any[];
  designationData;
  desinationId;
  readonly roleDetails = output<any>();
  requiredBool: boolean;
  debounceSubscription;
  companyHiringTypeId = localStorage.getItem('companyHiringTypeId');
  inputValue: any;
  selectedValue: any;

  ngOnInit() {
    // //console.log('Options LiSt', this.field.options);
    // //console.log('this.field.name', this.field.name)
    // //console.log('this.group', this.group);
    this.apiData.digitalTags.subscribe((res) => {
      this.digitalTags = res;
    });
    if (this.field.name === 'digitalTag') {
      this.filteredOptions = this.digitalTags;
    }
    this.debounceSubscription = this.group
      .get(this.field.name)
      .valueChanges.pipe(debounce(() => interval(1500)))
      .subscribe((value: any) => {
        //console.log(value,"autocomplete", typeof(value));
        if (value && value.length > 1) {
          this.inputValue = value;
          let urlValue = this.field?.url;
          if (this.field?.url?.includes('{0}')) {
            urlValue = this.field?.url?.replace('{0}', this.companyHiringTypeId);
          }
          if (typeof value == 'string') {
            //console.log("string");
            this._filter(value, urlValue);
          } else {
            //console.log("obj");
            this._filter(value.value, urlValue);
          }
        } else {
          this.filteredOptions = [];
        }
      });
    // if (this.field.name == 'designation') {
    //   // //console.log("designation----")
    //   if (this.field.value && this.field.value != undefined && this.field.value != null) {
    //     // //console.log("this.field.value --- ", this.field.value)
    //     this.http.get<any>(this.field.url + '/' + this.field.value).subscribe(data => {

    //       // //console.log("data---" + JSON.stringify(data))
    //       this.desinationId = data.find(val =>
    //         val.value === this.field.value
    //       )
    //       // //console.log("this.desinationId--" + this.desinationId.key)
    //       this.apiData.getDesignationData(this.desinationId.key).subscribe(res => {

    //         this.group.get('role').setValue(res.role);
    //         this.group.get('jobLevel').setValue(res.jobLevel);
    //         this.group.get('jobSublevel').setValue(res.jobSublevel);
    //       });

    //     });
    //   }
    // }
  }
  private _filter(value, url) {
    let filterValue = '';
    if (value !== null && value !== '') {
      filterValue = value.toLowerCase();
    }
    // if (this.field.name === "digitalOffering") {
    //   this.group.get('digitalTag').setValue('');
    // }
    if (this.field.url == null) {
      if (this.field.name === 'organisationName') {
        this.filteredOptions = this.field.options.filter((option) => option.value.toLowerCase().includes(filterValue));
        // //console.log("abc --" + this.filteredOptions)
        //
      } else {
        // //console.log(this.field,"ss");
        this.filteredOptions = this.field.options.filter((option) =>
          option?.value?.toLowerCase().includes(filterValue),
        );
        if (this.filteredOptions.length == 0) {
          this.group.get(this.field.name).setErrors({ dropdown: true });
        }
      }
    } else {
      if (filterValue !== null && filterValue != '') {
        if (this.field.name === 'digitalTag') {
          this.filteredOptions = this.digitalTags;
          // //console.log("this.digitalTags !== null", this.digitalTags)
          this.filteredOptions = this.filteredOptions.filter((option) =>
            option.value.toLowerCase().includes(filterValue),
          );
          if (this.filteredOptions.length == 0) {
            // //console.log(this.filteredOptions.length);
            this.group.get(this.field.name).setErrors({ error: true });
          }
        } else {
          if (this.field.name == 'institute') {
            if (filterValue.length > 2) {
              this.getFilterData(url, filterValue).subscribe((resp) => {
                // //console.log(filterValue);
                const temp = [];
                resp.forEach((res, _key) => {
                  temp.push({ key: res['instituteId'], value: res['instituteName'] });
                });
                this.filteredOptions = temp as Options[];
                if (this.filteredOptions.length == 0) {
                  // //console.log(this.filteredOptions.length);
                  this.group.get(this.field.name).setErrors({ required: true });
                }
              });
            }
          } else {
            this.getFilterData(url, filterValue).subscribe((resp) => {
              // //console.log(filterValue);
              this.filteredOptions = resp as Options[];
              if (this.filteredOptions.length == 0) {
                // //console.log(this.filteredOptions.length);
                this.group.get(this.field.name).setErrors({ required: true });
              }
            });
          }
        }
      }
    }
  }

  onInputBlur(event) {
    const urlValue = this.field?.url;
    if (typeof event.target.value == 'string') {
      //console.log("string");
      this._filter(event.target.value, urlValue);
    } else {
      //console.log("obj");
      this._filter(event.target.value.value, urlValue);
    }
    //console.log(this.filteredOptions[0]?.value,"filtered value",event.target.value,event.target.value.toLowerCase() != this.filteredOptions[0].value.toLowerCase());
    if (
      event &&
      this.filteredOptions.length > 0 &&
      event.target.value.toLowerCase() != this.selectedValue?.toLowerCase() &&
      this.field.name != 'organisationName'
    ) {
      // console.log("abc --" + this.filteredOptions[0].value,event.target.value)
      this.group.get(this.field.name).setErrors({ dropdown: true });
    }
  }

  onOptionSelected(event) {
    console.log(event, 'event');
    this.selectedValue = event.option?.value?.value;
  }

  getFilterData(url, value) {
    if (value !== null && value != '') {
      return this.http.get<any>(url[url.length - 1] == '=' ? url + value : url + '/' + value);
    }
  }

  // onchange(event) {
  //   if (this.field.name == 'designation') {
  //     this.apiData.getDesignationData(event).subscribe(data => {
  //       this.designationData = data;
  //       this.group.get('role').setValue(this.designationData.role);
  //       this.group.get('jobLevel').setValue(this.designationData.jobLevel);
  //       this.group.get('jobSublevel').setValue(this.designationData.jobSublevel);
  //     });
  //   }
  //   if (this.field.name == 'digitalOffering') {
  //     this.apiData.getDigitalTags(event).subscribe(data => {
  //       this.apiData.updateDigitalTags(data);
  //       this.group.get('digitalTag').setValue("");
  //       this.filteredOptions = [];
  //       this.apiData.digitalTags.subscribe(res => {
  //         this.digitalTags = res;
  //         this.filteredOptions = this.digitalTags;
  //         // //console.log("this.digitalTags", this.digitalTags)
  //       });
  //     });
  //   }

  // }

  changeMyControl(): void {
    // //console.log(this.group.get(this.field.name).value);
  }

  displayFn(event): string {
    // //console.log(event);
    return event && event.value ? event.value : '';
  }

  ngOnDestroy() {
    if (this.debounceSubscription) {
      this.debounceSubscription.unsubscribe();
    }
  }
}
